// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.r-search[data-v-32dcc7b4] {\n  max-width: 70%;\n  margin-right: 1%;\n}\n.dis-div[data-v-32dcc7b4] {\n  display: flex !important;\n}\n.border-button[data-v-32dcc7b4] {\n  border-radius: 15px;\n}\n", ""]);
// Exports
module.exports = exports;
